import axios from 'axios';
import { UPDATE_CATEGORY } from '../constants';

export const doChangeCategory = selected => {
  return { type: UPDATE_CATEGORY, selected }
}